import { useState } from 'preact/hooks'

function useProductForm() {
  const productState = window.productState
  const initProduct = productState.initProduct
  const [currentVariant, setCurrentVariant] = useState(initProduct.initVariant)
  const [properties, setProperties] = useState({})

  const updateCurrentVariant = (variant) => {
    if (currentVariant.id === variant.id) return
    setCurrentVariant(variant)
  }

  return {
    productState,
    initProduct,
    currentVariant,
    updateCurrentVariant,
    properties,
    setProperties
  }
}

export default useProductForm
